'use client';
import Link from 'next/link';
import styled, { css } from 'styled-components';

export const NavLink = styled(Link)`
  color: inherit;
  background-color: transparent;
  outline: none;
  border: none;
  margin-bottom: 2px !important;
  display: inline;

  &:hover {
    padding-bottom: 0;
    color: ${props => props.theme.colors.secondary.lilac};
  }

  @media ${props => props.theme.tablet} {
    ${props => props.theme.typography.body};
    color: inherit;
    &:last-child {
      margin-right: 0;
    }

    &:first-child {
      margin-left: 0;
    }
  }
`;

export const SmallNavLink = styled(NavLink)`
  display: ${props => (props.showLink ? 'inline' : 'none')};
  ${props => props.theme.typography.body};
  &:focus {
    outline: 0;
  }
  @media ${props => props.theme.mobileL} {
    display: inline;
  }
`;

export const Header = styled.header`
  display: block;
  background-color: ${props =>
    props.$fullBleedNav && !props.$scrolled
      ? 'transparent'
      : props.theme.colors.get(props.$bgColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  ${props =>
    props.$fullBleedNav &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      z-index: 100;
      transition: background-color 250ms ease-in-out;
    `};
  ${props =>
    !props.$fullBleedNav &&
    props.$sticky &&
    css`
      position: sticky;
      top: ${props => (props.$stickyBanner ? 0 : props.$hasBanner ? -48 : 0)}px;
      z-index: 100;
    `};
  ${props =>
    props.$cro &&
    css`
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
    `}
  ${props =>
    props.$centerLogo &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
  ${props =>
    props.$dropshadow &&
    css`
      min-height: 76px;
      width: 100%;
      filter: drop-shadow(0 1px 8px rgba(0, 0, 0, 0.05));
    `}
`;

export const StyledLoginButton = styled.button`
  display: ${props => (props.showButton ? 'inline' : 'none')};
  ${props => props.theme.typography.body};
  outline: none;
  border: none;
  color: inherit;
  padding: 14px 2px 2px 2px;
  &:focus,
  &:hover {
    text-decoration: none;
    padding-bottom: 0;
    border-bottom: 2px solid ${props => props.theme.colors.border.dark};
  }
  background: transparent;

  @media ${props => props.theme.mobileL} {
    display: inline;
    margin: 0 12px 2px;
  }
`;

export const StyledHeaderButton = styled.button`
  background: transparent;
  font-size: inherit;
  font-weight: inherit;
  font-family: inherit;
  display: inline;
  outline: none;
  color: inherit;
  border: none;
  padding: 0;
  &:focus,
  &:hover {
    text-decoration: none;
    padding-bottom: 0;
    border-bottom: 2px solid ${props => props.theme.colors.secondary.lilac};
  }
  margin-bottom: 2px !important;
  @media ${props => props.theme.tablet} {
    ${props => props.theme.typography.body};
  }
`;

// this handles the Profile Icon color change
export const StyledProfileWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(3)};
  svg {
    vertical-align: bottom;
  }
  &:hover {
    svg {
      fill: none;
      stroke: ${({ theme }) => theme.colors.secondary.lilac};
    }

    ${SmallNavLink} {
      color: ${({ theme }) => theme.colors.secondary.lilac};
      text-decoration: underline;
      text-underline-offset: ${props => props.theme.spacing(2)};
    }
  }
`;

export const DesktopButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(3)};
`;
